import { success, useCallback } from "@";
import { resendAll, resendSingle } from "./api";
import { messageResendConfirmDialog } from "./helpers";

// Hook to handle resending messages
export function useResendMessage(setData, fetchData) {
  // Function to resend a single message
  const sendSingle = useCallback(
    async (id) => {
      const res = await messageResendConfirmDialog();
      if (res) {
        try {
          await resendSingle(id);
          success("تم الارسال");
          setData((prevData) =>
            prevData.map((item) =>
              item.id === id ? { ...item, isSent: true } : item,
            ),
          );
        } catch (error) {}
      }
    },
    [setData],
  );

  // Function to resend multiple messages
  const sendMulti = useCallback(
    async (data) => {
      const res = await messageResendConfirmDialog();
      if (res) {
        try {
          await resendAll(data);
          fetchData();
          success("تم الارسال");
        } catch (error) {}
      }
    },
    [setData, fetchData],
  );

  return { sendSingle, sendMulti };
}
